import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddMisuseReport from "./ModalAddMisuseReport";

const useModalAddMisuseReport = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, misuse_report_id: null, mode: 'none',  })  ;

    const onClickActivate = ( misuse_report_id, newMode ) =>
    {
        switch ( newMode )
        {
            case 'delete':
                setDialog ({ openState: true, misuse_report_id: misuse_report_id, mode: 'delete'});
                break ;
            case 'create':
                setDialog ({ openState: true, misuse_report_id: misuse_report_id, mode: 'create'});
                break ;
            case 'edit':
                setDialog ({ openState: true, misuse_report_id: misuse_report_id,  mode: 'edit'});
                break ;
            case 'view':
                setDialog ({ openState: true, misuse_report_id: misuse_report_id,  mode: 'view'});
                break ;
        }
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, misuse_report_id: null, key: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, misuse_report_id: null, mode: 'none'});
        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddMisuseReport misuse_report_id={dialog.misuse_report_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddMisuseReport ;
